<his-documentation-link
	[target]="moduleOptions.DOCUMENTATION_ARTICLE"
	[title]="moduleOptions.DOCUMENTATION_TITLE">
</his-documentation-link>

<div>
	<!-- delete confirmation dialog from common package -->
	<res-confirmation-dialog></res-confirmation-dialog>
	<!-- res information dialog - record can not be deleted due to connections in other objects -->
	<res-information-dialog></res-information-dialog>

	<his-search-result #SearchResultComponent
		[showTitle]="true" 
		[showNewSearchButton]="false"
		[showChangeSearchButton]="false"
		defaultActionRoute="/pub/view/:id"
		idColumn="Publication.id"
		defaultColumn="Publication.title"
		[resultListTemplate]="resultListTemplate">
        
		<ng-template #resultListTemplate let-data let-firs="first" let-total="totalRecords" let-rows="rowsPerPage">
			<res-publication-duplicates-search-result-list
                [data]="data"
                [compName]="'duplicatesResultview'"
                [totalRecords]="total"
                [rowsPerPage]="rows"
                [first]="firs"
                [mainPublicationId]="mainPublicationId"
                [prevPage]="prevPage"
				(page)="onPage($event)">
			</res-publication-duplicates-search-result-list> 						   
		</ng-template>
	</his-search-result>
	<br/>
</div>
